/**
 * @desc 根据平台查询站点店铺
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteShopResponseDto>>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.cacheListByPlatform.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/cacheListByPlatform`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
